import { useState, useCallback } from 'react';

import { SortParams, SortParamsArg } from 'models';

export default function useSort(defaultSortParams: SortParams) {
  const [sortParams, setSortParams] = useState({
    ...defaultSortParams,
  });

  const changeSortParams = useCallback((params: SortParamsArg) => {
    setSortParams((prevState) => ({
      order: prevState.order === 'asc' ? 'desc' : 'asc',
      orderBy: params.id,
      type: params.type,
    }));
  }, []);

  return [sortParams, changeSortParams] as const;
}
